const PALETTE_ENABLED_KEY = "flux_performance_metrics_enabled";

export function isPaletteProfilingEnabled(): boolean {
    try {
        const storedValue = localStorage.getItem(PALETTE_ENABLED_KEY);
        return storedValue === "report-profiling";
    } catch (e) {
        return false;
    }
}
